import {ReactElement, ReactNode} from "react";
import {Box, Grid, IconButton, Stack, SxProps, Theme, Tooltip, Typography} from "@mui/material";
import {EMPTY_UI} from "../../../variables";
import {Colors} from "../Colors";
import EditIcon from "@mui/icons-material/Edit";
import {useTranslation} from "react-i18next";
import CopyToClipboard from "../../CopyToClipboard";

interface LabeledContentProps {
    label: string;
    color?: Colors;
    content?: number | string | ReactElement | ReactNode | null;
    icon?: ReactElement;
    xs?: number;
    md?: number;
    onEdit?: React.MouseEventHandler<HTMLButtonElement>;
    sx?: SxProps<Theme>;
    isCopyAlwaysVisible?: boolean;
    dataTest?: string;
}
const LabeledValue = ({
    label,
    content = EMPTY_UI,
    xs = 12,
    md = 6,
    color = Colors.BLACK,
    onEdit,
    sx,
    icon,
    isCopyAlwaysVisible = false,
    dataTest = "labeledValue",
}: LabeledContentProps) => {
    const {t} = useTranslation();
    content = content === null || (typeof content === "string" && !content.length) ? EMPTY_UI : content;
    const nodeToString = (node: LabeledContentProps["content"]) => {
        if (typeof node === "string" || typeof node === "number") {
            return `${node}`;
        } else {
            return undefined;
        }
    };
    const copyText = content !== EMPTY_UI ? nodeToString(content) : null;

    return (
        <Grid item xs={xs} md={md} sx={{flexBasis: "800px", marginTop: "14px", ...sx}} data-test={dataTest}>
            <Stack direction="row">
                <Typography variant={"subtitle2"} style={{margin: "auto 0"}}>
                    {label}
                </Typography>
                {onEdit && (
                    <Tooltip title={`${t("action_edit")}`}>
                        <IconButton onClick={onEdit}>
                            <EditIcon fontSize="small" />
                        </IconButton>
                    </Tooltip>
                )}
            </Stack>
            <Stack direction="row" justifyContent="flex-start" alignItems="center" spacing={1} className={"hasCopy"}>
                {icon && <Box>{icon}</Box>}
                <Box color={color}>{content}</Box>
                {copyText && <CopyToClipboard text={copyText} isAlwaysVisible={isCopyAlwaysVisible} />}
            </Stack>
        </Grid>
    );
};

export default LabeledValue;
